<button
  type="button"
  role="switch"
  class="esn-switch"
  [class.esn-switch--on]="checked()"
  [attr.aria-checked]="checked()"
  [attr.aria-label]="label()"
  [disabled]="disabled()"
  (click)="toggle()"
>
  <span class="esn-switch__knob">
    @if (icons()) {
      @if (checked()) {
        <esn-icon class="esn-switch__sun" name="sun" [size]="15" />
      } @else {
        <esn-icon class="esn-switch__moon" name="moon" [size]="12" />
      }
    }
  </span>
</button>
